import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const sizes = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
};

/**
 * Simple spinner for inline/button contexts.
 * Use this instead of LoadingSpinner when you need a small, clean spinner.
 *
 * For full-page or section loading, use LoadingSpinner (the branded TM logo grid).
 *
 * @param {Object} props
 * @param {'xs' | 'sm' | 'md' | 'lg' | 'xl'} props.size - Size preset (default: 'sm')
 * @param {string} props.className - Additional classes (for color, margin, etc.)
 */
export function Spinner({ size = 'sm', className }) {
  return (
    <Loader2 className={cn(sizes[size], 'animate-spin', className)} />
  );
}
